import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
import * as designSystem from '@domain-group/fe-co-allhomes-design-system';
var colour = variables.colour;
export var tabColour = colour.neutral900;
export var tabInactiveColour = colour.neutral700;
export var tabBorderColour = colour.accent;
export var tabCountColour = colour.neutral700;
export var tabList = {
  name: "1kmcw8",
  styles: "max-width:1024px;"
};
export var tabbedPanelContainer = {
  name: "1wma73l",
  styles: "display:flex;margin:0;margin-bottom:20px;"
};
export var subTitle = /*#__PURE__*/css(designSystem.typography.headingS, " margin-bottom:16px;");
export var duration = /*#__PURE__*/css("margin-left:5px;color:", colour.neutral500, ";&:before{content:'\u2022 ';}");
export var header = /*#__PURE__*/css("width:100%;margin:0;", designSystem.typography.headingL, " margin-bottom:20px;");